import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  paper: {
    minHeight: '500px',
    maxHeight: '500px',
  },
  nenhumexame: {
    paddingTop: theme.spacing(2),
  },
  chart: {
    maxHeight: '450px',
    marginTop: theme.spacing(1),
  },
}))

export default useStyles
